import gql from 'graphql-tag';
import { ShareTargetFragment } from 'services/apollo/fragments/coreFragments';

export const ProfileFeedAnlayticsQuery = gql`
  query getProfileFeedAnalytics($cursor: String!, $userId: String!) {
    profileByIdentifier(identifier: $userId) {
      ... on Person {
        name
      }
      ... on Profile {
        userNodes(first: 10, cursor: $cursor) {
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
        ownsNodes(first: 10, cursor: $cursor) {
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
        sharedWithNodes(first: 10, cursor: $cursor) {
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
      }
    }
  }
`;
export const getProfileActivityFeedQuery = gql`
  query getProfileActivityFeed($cursor: String!, $userId: String!, $includeGroups: Boolean!) {
    profileByIdentifier(identifier: $userId) {
      ... on Person {
        name
      }
      ... on Profile {
        userNodes(first: 10, cursor: $cursor) {
          nodes {
            ... on Node {
              id
              title
              baseUrl
              url
              modified
              created
              isIntegrationConnected
              integrationType
              category
              owners {
                id
                name
                email
                avatarUrl
              }
              accessorInfo(includeGroups: $includeGroups) {
                accessors {
                  ... on Group {
                    id
                    emoji
                    groupName: name
                  }
                  ... on Person {
                    id
                    name
                    email
                    avatarUrl
                  }
                }
                pageInfo {
                  endCursor
                  hasNextPage
                  total
                }
              }
              ...shareTargetResults @include(if: $includeGroups)
              sharingEnabled
              __typename
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
      }
    }
  }
  ${ShareTargetFragment}
`;

export const getProfileOwnsFeedQuery = gql`
  query getProfileOwnsFeed($cursor: String!, $userId: String!, $includeGroups: Boolean!) {
    profileByIdentifier(identifier: $userId) {
      ... on Person {
        name
      }
      ... on Profile {
        ownsNodes(first: 10, cursor: $cursor) {
          nodes {
            ... on Node {
              id
              title
              baseUrl
              url
              modified
              created
              isIntegrationConnected
              integrationType
              category
              owners {
                id
                name
                email
                avatarUrl
              }
              # ...shareTargetResults
              accessorInfo(includeGroups: $includeGroups) {
                accessors {
                  ... on Group {
                    id
                    emoji
                    groupName: name
                  }
                  ... on Person {
                    id
                    name
                    email
                    avatarUrl
                  }
                }
                pageInfo {
                  endCursor
                  hasNextPage
                  total
                }
              }
              ...shareTargetResults @include(if: $includeGroups)
              sharingEnabled
              __typename
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
      }
    }
  }
  ${ShareTargetFragment}
`;

export const getProfileSharedFeedQuery = gql`
  query getProfileSharedFeed($cursor: String!, $userId: String!, $includeGroups: Boolean!) {
    profileByIdentifier(identifier: $userId) {
      ... on Person {
        name
      }
      ... on Profile {
        sharedWithNodes(first: 10, cursor: $cursor) {
          nodes {
            ... on Node {
              id
              title
              baseUrl
              url
              modified
              created
              isIntegrationConnected
              integrationType
              category
              owners {
                id
                name
                email
                avatarUrl
              }
              # ...shareTargetResults
              accessorInfo(includeGroups: $includeGroups) {
                accessors {
                  ... on Group {
                    id
                    emoji
                    groupName: name
                  }
                  ... on Person {
                    id
                    name
                    email
                    avatarUrl
                  }
                }
                pageInfo {
                  endCursor
                  hasNextPage
                  total
                }
              }
              ...shareTargetResults @include(if: $includeGroups)
              sharingEnabled
              __typename
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
      }
    }
  }
  ${ShareTargetFragment}
`;
